import { Award } from 'lucide-react'

export default function AchievementCard() {
    return (
        <div className="bg-amber-50 rounded-lg p-6 border border-[rgba(239,177,0,0.20)]">
            <div className="flex justify-between items-center">
                <div className="space-y-4">
                    {[1, 2].map(index => (
                        <div key={index} className="space-y-2">
                            <div className="flex items-center gap-2">
                                <Award className="w-5 h-5 text-amber-400" />
                                <h3 className="font-medium">
                                    Won President medal
                                </h3>
                            </div>
                            <p className="text-sm text-gray-600 max-w-[550px] ml-7 break-words ">
                                Won the prestigious president medal for bravery
                                in the year 2021. I had saved a 14 yr old and
                                his mother from drowning.
                            </p>
                        </div>
                    ))}
                </div>
                <div className="flex-shrink-0 mr-6">
                    <img
                        src={'/images/gold_medal.svg'}
                        alt="Gold medal badge"
                        width={80}
                        height={80}
                        className="object-contain"
                    />
                </div>
            </div>
        </div>
    )
}
